import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { SalesDayPoint } from "@/core/pharmacy/dashboard-analytics";
import { formatMoneyCompact } from "@/core/pharmacy/format";

interface SalesTrendChartProps {
  data: SalesDayPoint[];
}

export function SalesTrendChart({ data }: SalesTrendChartProps) {
  return (
    <div className="ph-chart-wrap">
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="phSalesGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#14b8a6" stopOpacity={0.45} />
              <stop offset="100%" stopColor="#14b8a6" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => `${v}`}
          />
          <Tooltip
            content={({ active, payload }) => {
              if (!active || !payload?.[0]) return null;
              return (
                <div
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    background: "#fff",
                    boxShadow: "0 8px 24px rgba(15,23,42,0.08)",
                    fontSize: 13,
                  }}
                >
                  <strong>{formatMoneyCompact(Number(payload[0].value))}</strong>
                  <span className="text-muted ms-1">Ventes</span>
                </div>
              );
            }}
          />
          <Area
            type="monotone"
            dataKey="revenue"
            stroke="#0d9488"
            strokeWidth={2.5}
            fill="url(#phSalesGradient)"
            dot={{ r: 3, fill: "#0d9488", strokeWidth: 0 }}
            activeDot={{ r: 5, fill: "#0f766e" }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
